import React from 'react'
import SummaryChargesDetails from './summary-charges-details';

export default function SummaryChargesMobile(props) {
    const {toggleExpand, handleKeyDownSummaryCharges, charges, isExpanded, contentId, isMobileOrDesktop} = props;

    return (
    <div class="wth3-summaryCharges summaryChargesMobile"
        tabIndex={0} 
        role='button'
        onClick={toggleExpand} 
        onKeyDown={handleKeyDownSummaryCharges}
        aria-expanded={isExpanded}
        aria-controls={contentId}
        id='wth3SummaryCharges'
    >
        <SummaryChargesDetails charges={charges} isExpanded={isExpanded} contentId={contentId} isMobileOrDesktop={isMobileOrDesktop} />
    </div>
    )
}
